import React, {Component} from 'react';
import ClassNames from 'classnames';

class InputTextarea extends Component {

    constructor(props) {
        super(props);

        this.changeManager = this.changeManager.bind(this);
        this.blurManager = this.blurManager.bind(this);
    }

    changeManager(event) {
        const { methodChange } = this.props.configTextArea;
        if (methodChange) {
            methodChange(event.target.value, event.target.id);
        }
    }

    blurManager() {
        const { blurMethod, id } = this.props.configTextArea;
        if (blurMethod) {
            blurMethod(id);
        }
    }

    render() {
        const {
            id,
            icon,
            columns,
            formGroup,
            inlineIcon,
            controlValidate,
            placeHolder,
            rows,
            iconSpan
        } = this.props.configTextArea;
        return (
            <div className={columns}>
                <div className={ClassNames('form-group', formGroup)}>
                    <div className={inlineIcon}>
                        <textarea 
                            id={id} 
                            className={ClassNames('form-control', controlValidate)}  
                            placeholder={placeHolder} 
                            value={this.props.initialText}
                            rows={rows} 
                            onChange={this.changeManager} 
                            onBlur={this.blurManager} 
                        />
                        <span className={ClassNames(icon, iconSpan)}></span>
                    </div>
                </div>
            </div>
        );
    }

    componentDidMount() {
        let element = $("#" + this.props.configTextArea.id);
        const {
            id,
            readOnly,
            maxlength,
            numericKeyPress,
        } = this.props.configTextArea;

        if (readOnly) {
            element.attr('readonly', readOnly);
        }

        if (maxlength) {
            element.attr('maxlength', this.props.configTextArea.maxlength);
        }

        if (numericKeyPress) {
            $("#" + id).on("keypress keyup", (event) => {
                let element = $(event.currentTarget);
                element.val(element.val().replace(/[^\d].+/, ""));
                if ((event.which < 48 || event.which > 57)) {
                    event.preventDefault();
                }
            })
        }
    }
    
    componentDidUpdate() {
        let element = $("#" + this.props.configTextArea.id);
        if (this.props.hasOwnProperty("initialText")) {
            element.val(this.props.initialText);
        }
    }
}

export default InputTextarea;
